import { useEffect, useState } from 'react';
import Sketch from '@uiw/react-color-sketch';
import { ColorResult } from '@uiw/react-color';
import { generateTagColor, getAvailablePresetColors } from '../../../store/Tags';
import { DEFAULT_ADVANCE_BUTTON_STYLE, DEFAULT_CANCEL_BUTTON_STYLE } from '../../../utils/styleHelpers';

export interface TagColorPickerProps {
  color?: string;
  onChange?: (color: string) => Promise<void> | void;
  onSubmit?: (color: string) => Promise<void>;
  onClose?: () => void;
  showActions?: boolean;
}

export const TagColorPicker = ({ color, onChange, onSubmit, onClose, showActions = false }: TagColorPickerProps) => {
  const [hex, setHex] = useState(color || generateTagColor());
  const [presetColors, setPresetColors] = useState<string[]>([]);

  const handleSubmit = () => {
    onSubmit?.(hex);
  };

  const handleChange = (color: ColorResult) => {
    setHex(color.hex);
    onChange?.(color.hex);
  };

  const handleClose = () => {
    onClose?.();
  };

  useEffect(() => {
    setPresetColors(getAvailablePresetColors().slice(0, 16));
  }, []);

  const defaultStyles = {
    border: '0px',
    borderColor: 'transparent',
    borderRadius: '0px',
    backgroundColor: 'transparent',
    boxShadow: 'none'
  };

  return (
    <div data-testid="tag-color-picker">
      <Sketch
        style={defaultStyles}
        color={hex}
        disableAlpha={false}
        presetColors={presetColors}
        onChange={handleChange}
      />
      {showActions && (
        <div className="flex mt-2 justify-between">
          {onClose ? (
            <button
              onClick={handleClose}
              className={DEFAULT_CANCEL_BUTTON_STYLE}>
              Close
            </button>
          ) : (
            <div className="invisible"></div>
          )}
          {onSubmit && (
            <button
              onClick={handleSubmit}
              className={DEFAULT_ADVANCE_BUTTON_STYLE}>
              Save
            </button>
          )}
        </div>
      )}
    </div>
  );
};
